import { authHeaders, getAuthApiBaseUrl } from "./authApi";

async function parseJsonSafely(response) {
  try {
    return await response.json();
  } catch {
    return {};
  }
}

function toReadableError(payload, fallbackMessage) {
  return payload?.message || payload?.error || fallbackMessage;
}

/**
 * Authenticated user's Oshar reservations (Stripe + wallet-verified) from TreydoraEdBackend.
 * Uses the same API base as auth (`REACT_APP_API_BASE_URL` via getAuthApiBaseUrl).
 * Never logs tokens or Authorization headers.
 *
 * When `?debugPurchase=1` is on the page URL, `localStorage treydora:gateway-debug-moshar === "1"`, or
 * `options.debugPurchaseToBackend` is true, appends `?debugPurchase=1` so the backend can emit safe debug logs.
 *
 * @param {{ debugPurchaseToBackend?: boolean, signal?: AbortSignal }} [options]
 */
export async function getMyOsharReservations(options = {}) {
  const base = getAuthApiBaseUrl().replace(/\/+$/, "");
  const fromUrl =
    typeof window !== "undefined" &&
    (() => {
      try {
        return new URLSearchParams(window.location.search).get("debugPurchase") === "1";
      } catch {
        return false;
      }
    })();
  const debug =
    options.debugPurchaseToBackend === true ||
    fromUrl ||
    (typeof window !== "undefined" && window.localStorage?.getItem("treydora:gateway-debug-moshar") === "1");
  const qs = debug ? "?debugPurchase=1" : "";
  const res = await fetch(`${base}/api/oshar-real-estate/my-reservations${qs}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      ...authHeaders(),
    },
    signal: options.signal,
  });
  const data = await parseJsonSafely(res);
  if (!res.ok) {
    throw new Error(toReadableError(data, "Unable to load Oshar access records."));
  }
  return Array.isArray(data?.reservations) ? data.reservations : [];
}

/** @deprecated Use getMyOsharReservations */
export const fetchMyOsharReservations = getMyOsharReservations;
